var Ajax = function() {
    const buildQueryString = (data) => {
        let qs = '';
        Object.keys(data).forEach(((key, ix) => qs += `${ix != 0 ? '&' : ''}${key}=${data[key]}`));
        return qs;
    };

    const get = (url, success, async = true) => {
        url += `${url.includes('?') ? '&' : '?'}serving_mobile=${Generic.mobile}`;
        if (async) {
            return fetch(url).then(
                (res) => {
                    if (res.ok && res.status == 200) {
                        res.json().then(
                            (resJson) => {
                                success(resJson);
                            });
                    }
                }
            ).catch((error) => {
                // do nothing
            });
        } else {
            // TODO Remove sync version of get() when it is no more used
            const req = new XMLHttpRequest();
            req.open('GET', url, false);
            req.send();
            if (req.status == 200) {
                success(JSON.parse(req.responseText));
            }
        }
    };


    // data is either a key-value pairs object of the POST data
    // or the query string of the POST request
    const post = (url, data = {}, success = () => {}, cached_post = false) => {
        let body = '';
        if (cached_post) {
            // !! this is a cached POST request !!
            // It means all data must be included in the query string and not in POST body.
            // Moreover we must add serving_mobile in the URL too (and not in POST data as we normally do)
            // so the response is cached correctly for desktop VS mobile versions of HTML responses
            // NOTE: when cached_post=true then data param is ignored
            url += `${url.includes('?') ? '&' : '?'}serving_mobile=${Generic.mobile}`;
        } else {
            if (typeof data === 'string') {
                body = `${data}&serving_mobile=${Generic.mobile}`;
            } else {
                data['serving_mobile'] = Generic.mobile;
                body = buildQueryString(data);
            }
        }
        return fetch(
            url,
            {
                method: 'POST',
                body: body,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
            }
        ).then(
            (res) => {
                if (res.ok && res.status == 200) {
                    res.json().then(
                        (resJson) => {
                            success(resJson);
                        });
                }
            }
        ).catch((error) => {
            // do nothing
        });
    };

    return {
        // use this only if truly necessary
        get: function(url, success) {
            return get(url, success);
        },
        getPromoModal: function(cid, success) {
            return post('/api/promo_modal', {cid: cid}, success);
        },
        getAdModal: function(success) {
            return get('/api/ad_modal', success);
        },
        getVideoModal: function(vid, success) {
            return get('/api/video_modal?vid=' + vid, success);
        },
        getMatchHead: function(mid, success) {
            // !! Must be a cached POST request for proper nginx caching
            return post(`/api/live_single?mid=${mid}`, {}, success, true);
        },
        getMatchTab: function(mid, tab, success) {
            return post('/api/live_tab?mid=' + mid + '&tab=' + tab, {}, success);
        },
        getTziro: function(date, sortorder, ticker, success) {
            return get(
                `/api/live_tziros?date=${date}&ticker=${(ticker ? '1' : '0')}&sortorder=${(sortorder ? '0' : '1')}`,
                success
            );
        },
        getBasketMatches: function(date, byleague, success) {
            // !! Must be a cached POST request for proper nginx caching
            return post(
                '/api/live_basket?date=' + date + '&byleague=' + byleague,
                {},
                success,
                true
            );
        },
        getMobileMatchPage: function(basket, mid, full, success) {
            // !! Must be a cached POST request for proper nginx caching
            return post(
                '/api/mobile_matchpage?basket=' + (basket ? '1' : '0') +
                    '&update=' + (full ? '0' : '1') +
                    '&mid=' + mid,
                {},
                success,
                true
            );
        },
        getAnalyseis: function(editor_id, league_id, type, last_match_dt, last_match_id, success) {
            let params =
                'editor_id=' + editor_id +
                '&league_id=' + league_id +
                '&type=' + type +
                (last_match_dt ? '&last_match_dt=' + last_match_dt : '') +
                (last_match_id ? '&last_match_id=' + last_match_id : '')
            ;
            return get('/api/analyseis?' + params, success);
        },
        loadCommentaries: function(mid, success) {
            // !! Must be a cached POST request for proper nginx caching
            return post('/api/commentaries?mid=' + mid, {}, success, true);
        },
        getStandingsFiltersData: function(country, league, success) {
            let params = {c: country};
            if (league) {
                params.l = league;
            }
            return post('/api/standings_filters', params, success);
        },
        getTeamFiltersData: function(team, league, success) {
            return post('/api/team_filters', {t: team, l: league}, success);
        },
        login: function(username, password, success) {
            return post('/api/login', {username: username, password: password}, success);
        },
        logoff: function(callback) {
            return post('/api/logoff').finally(callback);
        },
        forgotPwd: function(email, success) {
            return post('/api/forgot_pwd', {e: email}, success);
        },
        comment: function(mid, is_news, cbody, success) {
            return post('/api/comment', {mid: mid, news: is_news, cbody: cbody}, success);
        },
        ignore: function(action, user_id, success) {
            return post('/api/ignore', {action: action, user_id: user_id}, success);
        },
        vote: function(mid, vote, always) {
            return post('/api/vote', {mid: mid, vote: vote},).finally(always);
        },
        delVote: function(vote_id, success) {
            return post('/api/delete_vote', {vote_id: vote_id}, success);
        },
        moderate: function(user_id, interval, success) {
            return post('/api/moderate', {user_id: user_id, interval: interval}, success);
        },
        getMatchStats: function(mid, expanded, selected_period, success) {
            return get(`/api/match_stats?mid=${mid}&expanded=${expanded}&selected_period=${selected_period}`, success);
        },
        subscribeSave: function(data, onSuccess) {
            return post('/api/subscribe_save', data, onSuccess);
        },
        profileSave: function(data, onSuccess) {
            return post('/api/profile_save', data, onSuccess);
        },
        profileReset: function(username, onSuccess) {
            return post('/api/profile_reset', {username_check: username}, onSuccess);
        },
        profileDelete: function(username, onSuccess) {
            return post('/api/profile_del', {username_check: username}, onSuccess);
        },
        getUserVotes: function(total, vpp, page, uid, success) {
            return get(`/api/user_votes?total=${total}&vpp=${vpp}&page=${page}&uid=${uid}`, success);
        },
        getFrontpages: function(date, success) {
            return get(`/api/frontpages?d=${date}`, success);
        },
        getNewspageArticles: function(excluded_news, news_offset, prs_offset, success) {
            return get(`/api/newspage_articles?excluded_news=${excluded_news}&news_offset=${news_offset}&prs_offset=${prs_offset}`, success);
        },
        getMoreNews: function(tag_id, team_id, date_until, success) {
            return get(`/api/more_news?tag_id=${tag_id}&team_id=${team_id}&date_until=${date_until}`, success);
        },
        getFeaturedGifs: function(limit, success) {
            return get(`https://tenor.googleapis.com/v2/featured?key=${Generic.tenor_api_key}&client_key=agones&country=${Generic.country}&locale=el_GR&&media_filter=mediumgif,gif,nanowebm,tinywebm&limit=${limit}`, success);

        },
        searchGifs: function(q, limit, success) {
            return get(`https://tenor.googleapis.com/v2/search?key=${Generic.tenor_api_key}&client_key=agones&country=${Generic.country}&locale=el_GR&&media_filter=mediumgif,gif,nanowebm,tinywebm&q=${encodeURIComponent(q)}&limit=${limit}`, success);
        },
        postPageProfData: function(domload, pageload, pid) {
            return post('/api/pprof', {domload: domload, pageload: pageload, pid: pid});
        },
        sendLinkTrackerImps: function(lids) {
            return post('/api/lti', {'lids': lids});
        },
        globalsearch: function(term, category, success) {
            return get(`/api/globalsearch?term=${term}&category=${category}`, success);
        },
        savePrefTheme: function(theme) {
            return post('/api/pref_save', {theme: theme});
        },
        savePrefGrouping: function(byleague) {
            return post('/api/pref_save', {byleague: byleague});
        },
        savePrefDefaultView: function(default_view) {
            return post('/api/pref_save', {default_view: default_view});
        },
        savePrefPinned: function(pinned, pinned_version) {
            let qs = '';
            pinned.forEach((val, ix) => qs += `${ix != 0 ? '&' : ''}pinned[]=${val}`);
            qs += `&pinned_version=${pinned_version}`;
            return post('/api/pref_save', qs);
        },
        savePrefLeaguesVisibility: function(leagues_visibility) {
            let qs = '';
            Object.entries(leagues_visibility)
                .forEach(([key, val], ix) => qs += `${ix != 0 ? '&' : ''}leagues_visibility[${key}]=${val}`);
            return post('/api/pref_save', qs);
        },
        savePrefOddsCompany: function(odds_company_id, success) {
            return post('/api/pref_save', {odds_company_id: odds_company_id}, success);
        },
        toggleFav: function(toggle_fav_mid, push_subscription_hash) {
            return post('/api/pref_save', {toggle_fav: toggle_fav_mid, push_subscription_hash: push_subscription_hash});
        },
        voteComment: function(comment_id, up_down, type, success) {
            return post(
                '/api/vote_comment',
                {
                    commentId: comment_id,
                    upDown: up_down,
                    type: type
                },
                success
            );
        },
        checkEmail: function(email, async, success) {
            // TODO Remove sync request when subscribe/verify code is rewritten
            return get(`/api/check_email?email=${email}`, success, async);
        },
        checkUsername: function(username, async, success) {
            // TODO Remove sync request when subscribe/verify code is rewritten
            return get(`/api/check_username?username=${username}`, success, async);
        },
        recordAction: function(action) {
            return post('/api/record_action', {action: action});
        },
        chatAdd: function() {
            return post('/api/chat_add');
        },
        loadMessages: function(uid, search, skip_mark, page, success, always = () => {}) {
            return post(
                '/api/messages',
                {
                    type: 'load',
                    uid: uid,
                    search: search,
                    skip_mark: skip_mark,
                    page: page
                },
                success
            ).finally(always);
        },
        sendMessage: function(uid, msg, search, skip_mark, page, success) {
            return post(
                '/api/messages',
                {
                    type: 'send',
                    uid: uid,
                    msg: msg,
                    search: search,
                    skip_mark: skip_mark,
                    page: page
                },
                success
            );
        },
        getLive: function(date, ticker, byleague, success) {
            // !! Must be a cached POST request for proper nginx caching
            return post('/api/live?date=' + date + '&ticker=' + ticker + '&byleague=' + byleague, {}, success, true);
        },
        autocompleteUsername(term, success) {
            return get(`/api/autocomplete_username?term=${term}&per_page=5`, success);
        },
        getTipsters(data, success) {
            return get(`/api/get_tipsters?${buildQueryString(data)}`, success);
        },
        sendSocketClientStats(data) {
            return post('/api/socket_client_stats', {data: data});
        },
        createSubscription(info, success) {
            return post('/api/push_subscriptions', {info: info}, success);
        },
        sendVerificationEmail(email, success) {
            return post('/api/send_verification_email', {email: email}, success);
        },
        getPlayerData(player_id, season, team_id, league_id, success) {
            return get(`/api/player?player_id=${player_id}&season=${season}&team_id=${team_id}&league_id=${league_id}`, success);
        },
        getUserData(success) {
            return get('/api/userdata', success);
        },
        getTeamMatches(tid, current_offset, success) {
            return get(`/api/team_matches?tid=${tid}&current_offset=${current_offset}`, success);
        },
        logopicker: function(term, success) {
            return get(`/api/logopicker?term=${term}`, success);
        },
        recordWebvitals: function(webvitals) {
            return post('/api/webvitals', webvitals);
        }
    };
}();

if (typeof module !== 'undefined') {
    module.exports = Ajax;
}
